export default __webpack_public_path__ + "static/media/promotion1.3737c192.jpg";